import DoorDash from '../../../images/DoorDash.png';

export const DoorDashIcon = () => (
  <div className="order-res-links-icon">
    <img src={DoorDash} alt="DoorDash" />
  </div>
);

export default DoorDashIcon;
